import { gql } from "@apollo/client";

const FIND_CRON_JOBS = gql`
  query FindCronJobs {
    findCronJobs {
      _id
      name
      schedule
      enabled
      status
      lastStartedAt
      lastFinishedAt
      lastSucceededAt
      lastFailedAt
      nextRunAt
      lastErrorMessage
      consecutiveFailureCount
      lastDurationMs
    }
  }
`;

const FIND_CRON_JOB_EXECUTIONS = gql`
  query FindCronJobExecutions($jobName: String!, $limit: Int) {
    findCronJobExecutions(jobName: $jobName, limit: $limit) {
      _id
      jobName
      status
      triggerType
      startedAt
      finishedAt
      durationMs
      scheduledFor
      error
    }
  }
`;

export { FIND_CRON_JOBS, FIND_CRON_JOB_EXECUTIONS };
